import { memo, useCallback, useState } from 'react'
import { Button, Toast } from '@ow/comps'
import { useTbViewStore } from '@vt/hooks'
import Confirm from '../confirm'

const download = (url) => {
  const a = document.createElement('a')
  a.href = url
  a.click()
}

const Exporter = ({ type }) => {
  const ditto = useTbViewStore((state) => state.ditto)
  const [loading, setLoading] = useState(false)
  const onExport = useCallback(async (close) => {
    setLoading(true)
    try {
      const { src } = await ditto.getExportUrl()
      download(src)
    } catch (err) {
      Toast.error({
        title: '提示',
        description: err.message || '导出失败',
      })
    }
    setLoading(false)
    close()
  }, [])
  return (
    <Confirm
      onConfirm={onExport}
      loading={loading}
      title={`导出的${type}数据不包含已禁用${type}，是否继续？`}
    >
      <Button className="h-6" size="sm" stroke>
        导出
      </Button>
    </Confirm>
  )
}

export default memo(Exporter)
